import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Tag } from "antd";
import { useCallback, useEffect, useLayoutEffect, useState } from "react";
import { useFormContentBlocker, useFormService, useI18n } from "../../contexts";
import { FormServiceLayout, FORM_VALUE_DIFFER_FROM_PRESET_TAG_APPLY_EVENT } from ".";
import { Notices } from "../common";
import { waitObject } from "@devowl-wp/react-utils";
const FORM_VALUE_DIFFER_FROM_PRESET_NOTICE_PSEUDO_ELEMENT_CLASS_NAME = "rcb-value-differ-from-template-pseudo";
const FormValueDifferFromTemplateNotice = (param)=>{
    let { containerRef, resetButton, resetButtonEvent = "click", form } = param;
    const { __, _i } = useI18n();
    const { isTemplateUpdate } = form === "service" ? useFormService() : useFormContentBlocker();
    const [pseudoElements, setPseudoElements] = useState([]);
    const [applied, setApplied] = useState(false);
    const updatePseudoElements = useCallback(()=>{
        if (containerRef.current) {
            const p = [
                ...containerRef.current.querySelectorAll(`.${FORM_VALUE_DIFFER_FROM_PRESET_NOTICE_PSEUDO_ELEMENT_CLASS_NAME}`)
            ];
            setPseudoElements(p);
            return p;
        }
        return [];
    }, [
        applied
    ]);
    useLayoutEffect(()=>{
        const interval = setInterval(updatePseudoElements, 800);
        waitObject(()=>containerRef.current, 100).then(updatePseudoElements);
        document.addEventListener(FORM_VALUE_DIFFER_FROM_PRESET_TAG_APPLY_EVENT, updatePseudoElements);
        return ()=>{
            clearInterval(interval);
            document.removeEventListener(FORM_VALUE_DIFFER_FROM_PRESET_TAG_APPLY_EVENT, updatePseudoElements);
        };
    }, []);
    const handleApply = ()=>{
        const p = updatePseudoElements();
        p.forEach((p)=>p.click());
        setPseudoElements([]);
        setApplied(true);
        if (p.length > 0) {
            // Run again as some fields can have conditional differences (e.g. dataProcessingInCountriesSpecialTreatments)
            setTimeout(handleApply, 0);
        }
    };
    useEffect(()=>{
        if (resetButton == null ? void 0 : resetButton.current) {
            const { current: resetButtonElement } = resetButton;
            if (pseudoElements.length > 0) {
                resetButtonElement.style.removeProperty("display");
            } else {
                resetButtonElement.style.display = "none";
            }
            resetButtonElement.addEventListener(resetButtonEvent, handleApply);
            return ()=>resetButtonElement.removeEventListener(resetButtonEvent, handleApply);
        }
        return ()=>{
        // Silence is golden.
        };
    }, [
        resetButton,
        resetButtonEvent,
        pseudoElements.length
    ]);
    return isTemplateUpdate && (pseudoElements.length > 0 || applied) ? /*#__PURE__*/ _jsx(Form.Item, {
        wrapperCol: {
            offset: FormServiceLayout.labelCol.span,
            span: FormServiceLayout.wrapperCol.span
        },
        style: {
            marginBottom: 0
        },
        children: /*#__PURE__*/ _jsx(Notices, {
            notices: [
                {
                    severity: "info",
                    message: /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            _i(__("The template has been updated to provide current legal and technical information. Fields with outdated values or values you manually adjusted are marked with {{tag/}}. You can apply all changes with one click!"), {
                                tag: /*#__PURE__*/ _jsx(Tag, {
                                    color: "blue",
                                    children: __("Differing from template")
                                })
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx("a", {
                                className: `button ${pseudoElements.length === 0 && applied ? "button-disabled" : ""}`,
                                onClick: handleApply,
                                style: {
                                    marginTop: 5
                                },
                                children: pseudoElements.length === 0 && applied ? __("Applied!") : __("Use default values")
                            })
                        ]
                    })
                }
            ]
        })
    }) : null;
};
export { FORM_VALUE_DIFFER_FROM_PRESET_NOTICE_PSEUDO_ELEMENT_CLASS_NAME, FormValueDifferFromTemplateNotice };
